import { usePasswordResetTokenCreate } from "@gocardless/api/dashboard/password-reset-token";
import { Trans } from "@lingui/macro";
import { useState } from "react";

import { errorNotificationHandler } from "src/common/notifications/notificationErrorHandlers";
import { useToastNotification } from "src/hooks/useToastNotification";

const TIME_DISABLE_BETWEEN_REQUESTS = 60000;

export const useResendPasswordResetEmail = () => {
  const [disableSubmission, setDisableSubmission] = useState<boolean>();
  const { triggerSuccessNotification, triggerErrorNotification } =
    useToastNotification();

  const [submit] = usePasswordResetTokenCreate({
    onSuccess: () => {
      triggerSuccessNotification({
        title: (
          <Trans id="resend-password-reset-email.toast.heading">
            Email sent
          </Trans>
        ),
        message: (
          <Trans id="resend-password-reset-email.toast.message">
            We&apos;ve sent a password reset email to the address associated
            with your account.
          </Trans>
        ),
        duration: 12000,
      });
    },
    onError: (error) => {
      errorNotificationHandler(error, triggerErrorNotification);
    },
  });

  const submitRequest = (email: string) => {
    setDisableSubmission(true);
    submit({ email });

    setTimeout(() => {
      setDisableSubmission(false);
    }, TIME_DISABLE_BETWEEN_REQUESTS);
  };

  return { submitRequest, disableSubmission };
};
